import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import userService from './userService'

const firebaseConfig = process.env.VUE_APP_ENVIRONMENT === 'production'
  ? {
    apiKey: 'AIzaSyABX1QSzfUOK-IL3Bo1hs5w0F0Bk7kEQ3k',
    authDomain: 'melon-online-push.firebaseapp.com',
    projectId: 'melon-online-push',
    storageBucket: 'melon-online-push.appspot.com',
    messagingSenderId: '305855019606',
    appId: '1:305855019606:web:4629eb807bd567ebda99f7',
    measurementId: 'G-T257B83YED'
  }
  : {
    apiKey: 'AIzaSyCOBMCf7uU67sHeBb0bIkz6QoGuincdvio',
    authDomain: 'test-melon-push.firebaseapp.com',
    projectId: 'test-melon-push',
    storageBucket: 'test-melon-push.appspot.com',
    messagingSenderId: '1029272305314',
    appId: '1:1029272305314:web:04b7fd815a0b459609e1fb',
    measurementId: 'G-DJGESD46BW'
  }

export default {
  async getToken() {
    const app = await initializeApp(firebaseConfig)
    const messaging = getMessaging(app)
    getToken(messaging, { vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY }).then((currentToken) => {
      if (currentToken) {
        userService.saveToken(currentToken)
      } else {
        console.log('No registration token available. Request permission to generate one.')
      }
    }).catch((err) => {
      console.log('An error occurred while retrieving token. ', err)
    })
  },
  getMessageNotification() {
    const myInterval = setInterval(() => {
      const userDetail = sessionStorage.getItem('user-detail')
      if (userDetail) {
        clearInterval(myInterval)
        const app = initializeApp(firebaseConfig)
        const messaging = getMessaging(app)
        onMessage(messaging, (payload) => {
          const notificationTitle = payload.notification.title
          const notificationOptions = {
            body: payload.notification.body.replace('{user_name}', JSON.parse(userDetail).displayName),
            icon: null
          }
          navigator.serviceWorker.ready.then((registration) => {
            registration.showNotification(notificationTitle, notificationOptions)
          })
        })
      }
    }, 1000)
  }
}
